import { render } from "./DaysOfInventoryCard.vue?vue&type=template&id=3bf8847e"
import script from "./DaysOfInventoryCard.vue?vue&type=script&lang=js"
export * from "./DaysOfInventoryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__